import { clx } from '@medusajs/ui';
import type { ReactNode } from 'react';

export const Paragraph = ({
  indentLevel = 0,
  children,
}: {
  indentLevel?: number;
  children: ReactNode;
}) => {
  return (
    <p
      className={clx('text-black-20 mt-2', {
        'pl-4': indentLevel === 1,
        'pl-8': indentLevel === 2,
        'pl-12': indentLevel === 3,
        'pl-16': indentLevel === 4,
      })}
    >
      {children}
    </p>
  );
};
